/*
 * Growave 리뷰 표시 수정 - footsgo용 (storefront 화면 표시만 변경, Growave 원본 데이터는 그대로).
 *
 *  - 리뷰 카드 하단의 "レビューをインポートしました" 안내(아이콘 + 문구)를 숨긴다.
 *  - 작성자 이름을 stoBIG와 같은 규칙으로 표시한다: 공백으로 나뉜 이름은 첫 부분 + " **"
 *    (예: 孝子 *. → 孝子 **, 節夫 川. → 節夫 **), 이미 "○○ **"/"**"면 그대로, 한 단어는 "**",
 *    빈 이름·익명은 그대로. (stoBIG용 스크립트와 같은 코드 - MASK_AUTHOR_NAMES = true)
 *  - 별점·본문·사진·날짜·좋아요·구매 인증 배지·쇼핑몰 답글은 건드리지 않는다.
 *
 * 구조(stoBIG에서 확인한 것과 동일한 Growave 위젯):
 *  - 리뷰 목록·사진 팝업·리뷰 사이드바는 각각 open Shadow DOM 안에 그려지고, 사이드바는 shadow root
 *    안에 shadow root가 한 번 더 있다(.gw-rv-widget-container). 테마 CSS가 닿지 않으므로 JS로 처리한다.
 *  - 가져오기 안내: 카드(li.gw-rv-item / .gw-rv-modal-content) 안 .gw-tooltip__trigger 중 문구가
 *    가져오기 안내인 것 (공식 구매 인증 배지도 같은 클래스라서 반드시 문구로 구분한다).
 */
(function () {
  'use strict';

  if (window.__gwrpDisplayFix) return; // 중복 로드 방지
  window.__gwrpDisplayFix = true;

  // 리뷰 목록(.gw-rv-main-widget-placeholder)과 사진 팝업(.gw-reviews-modal-widget-placeholder)은
  // 서로 다른 shadow host에 그려진다.
  var HOST_SELECTOR = '[class*="gw-rv"], [class*="gw-reviews"]';
  // 목록의 리뷰 카드 + 사진을 눌렀을 때 뜨는 리뷰 팝업(같은 이름·가져오기 안내가 다시 표시됨)
  var CARD_SELECTOR = 'li.gw-rv-item, .gw-rv-modal-content';
  var NAME_SELECTOR = 'p.gw-text--heading-md';
  var REPLY_SELECTOR = '.gw-rv-item-reply';
  var TRIGGER_SELECTOR = '.gw-tooltip__trigger';
  var IMPORT_TEXT_RE = /レビューをインポートしました|Imported review|Review imported|리뷰를\s*가져왔습니다/i;
  var ANONYMOUS_RE = /^(匿名|Anonymous|익명)$/i;
  var HIDDEN_ATTR = 'data-gwrp-hidden';
  var SCAN_INTERVAL_MS = 1000;
  var MASK_AUTHOR_NAMES = true; // stoBIG와 같은 이름 규칙(첫 부분 + " **")

  var observedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function maskName(raw) {
    var name = (raw || '').trim();
    if (!name) return raw;
    if (name === '**' || /\s\*\*$/.test(name)) return raw;
    if (ANONYMOUS_RE.test(name)) return raw;
    var parts = name.split(/\s+/).filter(Boolean); // \s에는 전각 공백(U+3000)도 포함된다
    if (parts.length >= 2) return parts[0] + ' **';
    return '**';
  }

  function maskNameEl(el) {
    // Svelte가 관리하는 텍스트 노드를 교체하지 않고 값만 바꾼다(재렌더링과 충돌 방지).
    // 이미 가린 값은 maskName이 그대로 돌려주므로 다시 바뀌지 않는다.
    var walker = el.ownerDocument.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.data.trim()) continue;
      var masked = maskName(node.data);
      if (masked !== node.data) node.data = masked;
      return;
    }
  }

  function findAuthorNameEl(card) {
    var candidates = card.querySelectorAll(NAME_SELECTOR);
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest(REPLY_SELECTOR)) return candidates[i];
    }
    return null;
  }

  function hideImportLabels(card) {
    var triggers = card.querySelectorAll(TRIGGER_SELECTOR);
    for (var i = 0; i < triggers.length; i++) {
      var t = triggers[i];
      if (t.hasAttribute(HIDDEN_ATTR)) continue;
      if (t.closest(REPLY_SELECTOR)) continue;
      if (!IMPORT_TEXT_RE.test(t.textContent || '')) continue; // 공식 구매 인증 배지는 문구가 없어 제외됨
      t.setAttribute(HIDDEN_ATTR, 'import-label');
      t.setAttribute('aria-hidden', 'true');
      t.removeAttribute('tabindex');
      t.style.setProperty('display', 'none', 'important');
    }
  }

  function processRoot(root) {
    var cards = root.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      var nameEl = findAuthorNameEl(cards[i]);
      if (MASK_AUTHOR_NAMES && nameEl) maskNameEl(nameEl);
      hideImportLabels(cards[i]);
    }
  }

  function watchRoot(root) {
    if (observedRoots) {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
    } else {
      if (root.__gwrpObserved) return;
      root.__gwrpObserved = true;
    }
    processRoot(root);
    // MutationObserver 콜백은 화면을 그리기 전에 실행되므로 원래 이름/문구가 깜빡이지 않는다.
    // 이미 처리된 이름은 maskName이 그대로 돌려주므로 값이 바뀌지 않아 무한 반복이 생기지 않는다.
    new MutationObserver(function () {
      processRoot(root);
      scanHosts(root, 1); // 안쪽에 새로 생긴 shadow host(사이드바 목록 등)도 바로 감시
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  // 리뷰 사이드바(.gw-reviews-drawer-widget-placeholder)는 shadow root 안에 또 다른 shadow root
  // (.gw-rv-widget-container)를 두고 그 안에 카드를 그리므로 안쪽까지 따라 들어간다.
  function scanHosts(root, depth) {
    if (depth > 4) return;
    var hosts = root.querySelectorAll(HOST_SELECTOR);
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].shadowRoot) continue;
      watchRoot(hosts[i].shadowRoot);
      scanHosts(hosts[i].shadowRoot, depth + 1);
    }
  }

  function scan() {
    scanHosts(document, 0);
    // Shadow DOM 없이 그려지는 경우(Growave 구조 변경 대비)에도 동일하게 처리한다.
    if (document.querySelector(CARD_SELECTOR)) processRoot(document);
  }

  scan();
  // shadowRoot 생성은 MutationObserver로 감지되지 않으므로, 늦게 로딩되는 위젯·이미지 팝업 등은
  // 가벼운 주기 검사로 찾는다(이미 감시 중인 root는 건너뜀).
  setInterval(scan, SCAN_INTERVAL_MS);
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('pageshow', scan);
})();
